// extracted by mini-css-extract-plugin
export default {"root":"HorizontalRule-root-fa23a9f3a031bedb24f08c67e4925903"};